import { Box, Button, Flex, Link, Text } from '@chakra-ui/react'
import useTranslation from 'next-translate/useTranslation'

import { CookieConsentStatus } from 'constants/localStorage'
import { ExternalUrls } from 'constants/routes'
import { zIndex } from 'constants/zIndex'
import { useCookieConsent } from 'providers/CookieConsentProvider'

export const CookieConsentBanner = () => {
  const { t } = useTranslation('common')
  const { isCookieConsentBannerOpen, saveConsentStatus } = useCookieConsent()

  if (!isCookieConsentBannerOpen) {
    return null
  }

  return (
    <Box
      role="dialog"
      aria-label={t('CookieConsent.title')}
      position="fixed"
      bottom={{ base: 0, md: '24px' }}
      left={{ base: 0, md: '24px' }}
      right={{ base: 0, md: 'auto' }}
      maxW={{ base: 'full', md: '480px' }}
      p="24px"
      bg="brand.white"
      borderRadius={{ base: 0, md: '8px' }}
      boxShadow="0px 4px 24px rgba(0, 0, 0, 0.16)"
      zIndex={zIndex.CookieConsentBanner}
    >
      <Text fontSize="18px" fontWeight="semibold" mb="8px">
        {t('CookieConsent.title')}
      </Text>
      <Text fontSize="14px" lineHeight="20px" color="brand.darkBlueGray">
        {t('CookieConsent.description')}{' '}
        <Link
          href={ExternalUrls.cookiePolicy}
          isExternal
          color="brand.ultramarine"
          textDecoration="underline"
        >
          {t('CookieConsent.cookiePolicy')}
        </Link>
      </Text>
      <Flex mt="20px" gap="12px" justify="flex-end">
        <Button
          variant="outline"
          onClick={() => saveConsentStatus(CookieConsentStatus.Denied)}
        >
          {t('CookieConsent.reject')}
        </Button>
        <Button onClick={() => saveConsentStatus(CookieConsentStatus.Granted)}>
          {t('CookieConsent.accept')}
        </Button>
      </Flex>
    </Box>
  )
}
